var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHidePassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.56536 5.45833L1.66536 3.55833L2.7237 2.5L17.4987 17.275L16.4404 18.3333L13.9987 15.9L13.6487 15.55C12.5237 16 11.2904 16.25 9.9987 16.25C5.83203 16.25 2.2737 13.6583 0.832031 10C1.48203 8.35 2.56536 6.91667 3.9487 5.84167L3.56536 5.45833ZM14.1635 10C14.1635 7.7 12.2969 5.83333 9.99687 5.83333C9.45521 5.83333 8.94687 5.94167 8.47188 6.13333L6.67188 4.33333C7.70521 3.95833 8.82188 3.75 9.98854 3.75C14.1552 3.75 17.7135 6.34167 19.1552 10C18.5469 11.55 17.5552 12.9083 16.2969 13.9583L13.8635 11.525C14.0552 11.05 14.1635 10.5417 14.1635 10ZM6.2737 8.16602L7.56536 9.45768C7.5237 9.63268 7.4987 9.81602 7.4987 9.99935C7.4987 11.3827 8.61536 12.4993 9.9987 12.4993C10.182 12.4993 10.3654 12.4743 10.5404 12.4327L11.832 13.7243C11.2737 13.9993 10.657 14.166 9.9987 14.166C7.6987 14.166 5.83203 12.2993 5.83203 9.99935C5.83203 9.34102 5.9987 8.72435 6.2737 8.16602ZM12.4922 10.1411L9.86719 7.51615L10.0089 7.50781C11.3922 7.50781 12.5089 8.62448 12.5089 10.0078L12.4922 10.1411Z",
    fill: "#BBBEC9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHidePassword);
export default __webpack_public_path__ + "static/media/hide-password.72286ceb8f2574da8caba7e779aab9ed.svg";
export { ForwardRef as ReactComponent };